import * as Sentry from '@sentry/angular';

const whitelabels = ['fjordkraft', 'elywhere', 'electricfreeway', 'chargebnb', 'glup', 'rexel', 'wennstrom'] as const;

type Whitelabel = (typeof whitelabels)[number];

type Environment = Whitelabel | 'prod' | 'qa' | 'staging' | 'localhost' | 'sandbox';

export function getEnvironment(): Environment {
  let result: Environment = 'localhost';

  const rawDomain = window.location.hostname;
  const [domain] = rawDomain.split('.');

  if (domain === 'portal') {
    result = 'prod';
  } else if (domain === 'staging') {
    result = 'staging';
  } else if (domain === 'qa') {
    result = 'qa';
  } else if (domain === 'sandbox') {
    result = 'sandbox';
  } else if (whitelabels.includes(domain as Whitelabel)) {
    result = domain as Whitelabel;
  }

  return result;
}

export function enableSentry() {
  Sentry.init({
    environment: getEnvironment(),
    dsn: 'https://4e45b0696f2db72e68baa3753ad5ccad@o4511613361520640.ingest.de.sentry.io/4511613383147600',
    integrations: [],
    tracesSampleRate: 1.0,
    attachStacktrace: true
  });
}
